import axios from "axios";
import { ApiError } from "../../Models/ApiError";
import { HandleError } from "../../Helpers/ErrorHandler";
import { ScanItemResponse } from "../../Models/ScanItemResponse";
import { ScanItemFirstRequest } from "../../Models/ScanItemFirstRequest";
import { PickItemRequest } from "../../Models/PickItemRequest";
import { PickItemResponse } from "../../Models/PicktemResponse";
import { UnpickItemRequest } from "../../Models/UnpickItemRequest";
import { ScanItemSecondRequest } from "../../Models/ScantemSecondRequest";
import { PackItemRequest } from "../../Models/PackItemRequest";
import { PackItemResponse } from "../../Models/PackItemResponse";
import { PrePickItemRequest } from "../../Models/PrePickItemRequest";
import { PrePickItemResponse } from "../../Models/PrePickItemResponse";
import { UnPrePickItemRequest } from "../../Models/UnPrePickItemRequest";
import { TallyBarcodeResponse, SetStockBarcodeResponse } from "../../Models/TallyBarcodeResponse";
import { PostTalliesRequest } from "../../Models/PostTalliesRequest";
import { DeleteTalliesRequest } from "../../Models/DeleteTalliesRequest";
import { TransHeaderResponse } from "../../Models/TransHeaderResponse";

const API_URL = process.env.REACT_APP_API_URL;

export const markItemAsScannedAPI = async (model: PickItemRequest, serverUrl: string, dbKey: string): Promise<PickItemResponse> => {
  return new Promise<PickItemResponse>((resolve, reject) => {
    axios
      .post<PickItemResponse>(`${API_URL}item/pick?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const unpickItemAPI = async (model: UnpickItemRequest, serverUrl: string, dbKey: string): Promise<PickItemResponse> => {
  return new Promise<PickItemResponse>((resolve, reject) => {
    axios
      .post<PickItemResponse>(`${API_URL}item/unpick?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const scanItemFirstAPI = async (
  barcode: string,
  serverUrl: string,
  dbKey: string,
  orderCompanyNo?: number,
  transNo?: string,
  includeSerialQty?: boolean,
): Promise<ScanItemResponse> => {
  const model: ScanItemFirstRequest = {
    barcode,
    orderCompanyNo,
    transNo,
    includeSerialQty,
  };
  return new Promise<ScanItemResponse>((resolve, reject) => {
    axios
      .post<ScanItemResponse>(`${API_URL}item/scanitemfirst?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const scanItemSecondAPI = async (
  binCode: string,
  stockCode: string,
  serverUrl: string,
  dbKey: string,
  orderCompanyNo?: number,
  transNo?: string,
): Promise<ScanItemResponse> => {
  const model: ScanItemSecondRequest = {
    binCode,
    stockCode,
    orderCompanyNo,
    transNo,
  };
  return new Promise<ScanItemResponse>((resolve, reject) => {
    axios
      .post<ScanItemResponse>(`${API_URL}item/scanitemsecond?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const prePickItemAPI = async (model: PrePickItemRequest, serverUrl: string, dbKey: string): Promise<PrePickItemResponse> => {
  return new Promise<PrePickItemResponse>((resolve, reject) => {
    axios
      .post<PrePickItemResponse>(`${API_URL}item/prepick?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const unPrePickItemAPI = async (model: UnPrePickItemRequest, serverUrl: string, dbKey: string): Promise<PrePickItemResponse> => {
  return new Promise<PrePickItemResponse>((resolve, reject) => {
    axios
      .post<PrePickItemResponse>(`${API_URL}item/unprepick?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const packAPI = async (model: PackItemRequest, serverUrl: string, dbKey: string): Promise<PackItemResponse> => {
  return new Promise<PackItemResponse>((resolve, reject) => {
    axios
      .post<PackItemResponse>(`${API_URL}item/pack?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const validateTallyBarcodeAPI = async (
  stockNo: number,
  barcode: string,
  serverUrl: string,
  dbKey: string,
): Promise<TallyBarcodeResponse> => {
  return new Promise<TallyBarcodeResponse>((resolve, reject) => {
    const url = `${API_URL}item/tallybarcode?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}&stockNo=${stockNo}&barcode=${encodeURI(barcode)}`;
    axios
      .get<TallyBarcodeResponse>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

//saves the scanned barcode against a stock that has none, once the operator has agreed to it
export const setTallyStockBarcodeAPI = async (
  stockNo: number,
  barcode: string,
  serverUrl: string,
  dbKey: string,
): Promise<SetStockBarcodeResponse> => {
  return new Promise<SetStockBarcodeResponse>((resolve, reject) => {
    const url = `${API_URL}item/tallystockbarcode?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}&stockNo=${stockNo}&barcode=${encodeURI(barcode)}`;
    axios
      .post<SetStockBarcodeResponse>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const postTalliesAPI = async (model: PostTalliesRequest, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}item/tally?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const deleteTalliesAPI = async (model: DeleteTalliesRequest, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}item/tally/delete?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
